/* @flow */
import eui64 from 'eui64'
import axios from 'axios'

export const eui = (value: string) => value === undefined || !!eui64(value)
export const number = (value: mixed) => value === undefined || !isNaN(value)
export const uuid = (value: string) =>
  /[0-9|a-f]{32}/i.test(value.replace(/-/g, '')) &&
  value.replace(/-|~[0-9|a-f]/gi, '').length === 32

export const uniqueEui = async (value: string) => {
  if (!value) return true

  try {
    await axios.get(`/euis/${value}/validate`)
    return true
  } catch (error) {
    return false
  }
}

export const appKey = (value: string) => {
  if (!value) return true
  // Check for any characters besides HEX, '-', or '.'
  if (value.match(/[^\da-f-.]/gi)) return false
  // Strip everything but hex and verify length
  if (value.replace(/[^\da-f]/gi, '').length !== 32) return false
  return true
}

export const extractValidations = (config: Object[]) => {
  const validations = {}
  config.filter(field => 'validations' in field).map(field => {
    validations[field.attribute] = field.validations
  })
  return validations
}

export const operationMessage = (value: string) => {
  if (!value) return true
  if ( !value.match(/^([a-f]|\d){0,484}$/i) ) return false
  // if (value.length < 1) return false
  if (value.length > 484) return false
  if (value.length % 2 !== 0) return false
  return true
}

export const customUrlValidation = (url) => { 
  const validURL = new RegExp(/^(|.+:\/\/.+$)/)
  return validURL.test(url)
}

// https://datatracker.ietf.org/doc/rfc7043/?include_text=1
// 4.2.  EUI64 RR Presentation Format
// The Address field MUST be represented as eight two-digit hexadecimal
// numbers separated by hyphens.  The hexadecimal digits "A" through "F"
// MAY be represented in either upper or lower case.

export const euiHint = 'Eight two-digit hexadecimal numbers separated by hyphens'

export const validationMessages = {
  required: 'Required',
  requiredIf: 'Required',
  url: 'Not a valid URL',
  customUrlValidation: 'Not a valid URL or IP address',
  minValue: 'Minimum value is {min}',
  maxValue: 'Maximum value is {max}',
  minLength: 'Must be at least {min} characters',
  maxLength: 'Must be no more than {max} characters',
  eui: 'Must contain eight two-digit hexadecimal numbers separated by hyphens',
  uniqueEui: 'This EUI is already taken',
  number: 'Must be a number',
  uuid: 'Must be a 128-bit hexadecimal string or UUID',
  appKey: "AppKeys must contain 16 octets, optionally separated by '.' or '-'",
  email: 'Not a valid email',
}



// WEBPACK FOOTER //
// ./src/validations.js